module.exports = __webpack_public_path__ + "img/depmap_svg_V40.e51934c4.svg";